import Vue from 'vue';

const notify = notification => {
    const base = {
        position: 'top right',
        duration: 5000,
        type: 'warn',
        group: 'global'
    };

    Vue.notify( Object.assign( {}, base, notification ) );
};

export default notify;



// WEBPACK FOOTER //
// ./src/notifications/index.js